// APP DATA
export const LOAD_APP_SETTINGS = 'APP/load';

export function loadAppSettings(settings) {
  return { type: LOAD_APP_SETTINGS, payload: settings }
}

export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';

export function showModal(modalType, modalProps, modalContentProps) {
  return { type: MODAL_SHOW, payload: { modalType, modalProps, modalContentProps } }
}

export function hideModal(id) {
  return { type: MODAL_HIDE, payload: { id } }
}

export const SET_WORKING_FOLDER = 'WORKING_FOLDER/set';
export const CLEAR_WORKING_FOLDER = 'WORKING_FOLDER/clear';

export function setWorkingFolder(id, name, view, permissions) {
  return { type: SET_WORKING_FOLDER, payload: { id, name, view, permissions } }
}

export function clearWorkingFolder() {
  return { type: CLEAR_WORKING_FOLDER, payload: { id: null, name: null } }
}

export const INITIATE_DOWNLOAD = 'DONWLOAD/start';

export function initiateDownload(data) {
  return { type: INITIATE_DOWNLOAD, payload: { ...data } }
}

export const RESET_DOWNLOAD = 'DOWNLOAD/reset';

export function resetDownload() {
  return { type: RESET_DOWNLOAD }
}

// APP DATA
export const LOAD_USER_DATA = 'USER/load';

export function loadUserData(userData) {
  return { type: LOAD_USER_DATA, payload: userData }
}

// PORTAL
export const LOAD_PORTAL = 'PORTAL/load';

export function loadPortal(portalComponents) {
  return { type: LOAD_PORTAL, payload: portalComponents }
}

// ContextMenu
export const CONTEXT_MENU_SHOW = 'CONTEXT_MENU/show';
export const CONTEXT_MENU_HIDE = 'CONTEXT_MENU/hide';

export function showContextMenu(menuProps) {
  return { type: CONTEXT_MENU_SHOW, payload: menuProps }
}

export function hideContextMenu() {
  return { type: CONTEXT_MENU_HIDE }
}

// Legacy Dialogs
export const LEGACY_DIALOG_SHOW = 'LEGACY_DIALOG/show';
export const LEGACY_DIALOG_HIDE = 'LEGACY_DIALOG/hide';

export function showLegacyDialog(dialogType, dialogProps, dialogContentProps) {
  return { type: LEGACY_DIALOG_SHOW, payload: { dialogType, dialogProps, dialogContentProps } }
}

export function hideLegacyDialog() {
  return { type: LEGACY_DIALOG_HIDE }
}